import { AvailableVehicles } from "./AvailableVehicles";

export class ReusableVehicles extends AvailableVehicles{
    
}


// WEBPACK FOOTER //
// ./src/app/utilities/Scheduling/ReusableVehicles.ts